/* Плашка сообщения. Цвета — токены ОТВЕТО, как у остальных компонентов кита. */

.root {
	display: flex;
	align-items: flex-start;
	gap: 10px;
	width: 100%;
	box-sizing: border-box;
	padding: 12px 16px;
	border-radius: var(--Border-radius-M);
	color: var(--text-constant-dark);
	font-size: 14px;
	font-weight: 400;
	line-height: 150%;
	letter-spacing: 0.14px;
}

.icon {
	flex-shrink: 0;
	/* Иконка на первой строке текста, а не по центру плашки: сообщение бывает в две строки */
	margin-top: 1px;
}

.body {
	min-width: 0;
}

.error {
	background: var(--bg-error-quartiary);
}

.error .icon {
	color: var(--icon-error);
}

.warning {
	background: var(--bg-warning-tertiary);
}

.info {
	background: var(--bg-accent-quartiry);
}

.info .icon {
	color: var(--icon-accent);
}

/* Закрытие — служебное действие плашки, тише её содержания */
.close {
	display: inline-flex;
	flex: none;
	margin-left: auto;
	padding: 2px;
	border: none;
	background: none;
	color: var(--text-secondary);
	font-size: 16px;
	cursor: pointer;
}

.close:hover {
	color: var(--text-constant-dark);
}
